/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const ganttExportConfig = {
  'layout'                       : {
    'css' : 'redtheme',
    'rows': [
      {
        'cols': [
          {
            'view'   : 'grid',
            'scrollX': 'scrollHor',
            'scrollY': 'scrollVer',
          },
          {
            'resizer': true,
            'width'  : 1,
          },
          {
            'view'   : 'timeline',
            'scrollX': 'scrollHor',
            'scrollY': 'scrollVer',
          },
          {
            'view': 'scrollbar',
            'id'  : 'scrollVer',
          },
        ],
      },
      {
        'view'  : 'scrollbar',
        'id'    : 'scrollHor',
        'height': 20,
      },
    ],
    'id'  : 'main',
  },
  'links'                        : {
    'finish_to_start' : '0',
    'start_to_start'  : '1',
    'finish_to_finish': '2',
    'start_to_finish' : '3',
  },
  'types'                        : {
    'task'     : 'task',
    'project'  : 'project',
    'milestone': 'milestone',
  },
  'duration_unit'                : 'day',
  'work_time'                    : false,
  'correct_work_time'            : false,
  'skip_off_time'                : false,
  'cascade_delete'               : true,
  'autosize'                     : false,
  'autosize_min_width'           : 0,
  'autoscroll'                   : true,
  'autoscroll_speed'             : 30,
  'show_links'                   : true,
  'show_task_cells'              : true,
  'static_background'            : false,
  'branch_loading'               : false,
  'branch_loading_property'      : '$has_child',
  'show_loading'                 : false,
  'show_chart'                   : true,
  'show_grid'                    : true,
  'min_duration'                 : 3600000,
  'xml_date'                     : '%Y-%m-%d+%H:%i',
  'api_date'                     : '%d-%m-%Y+%H:%i',
  'start_on_monday'              : false,
  'server_utc'                   : false,
  'show_progress'                : true,
  'fit_tasks'                    : false,
  'select_task'                  : true,
  'scroll_on_click'              : true,
  'preserve_scroll'              : true,
  'readonly'                     : false,
  'date_grid'                    : '%Y-%m-%d',
  'round_dnd_dates'              : true,
  'link_wrapper_width'           : 20,
  'root_id'                      : 0,
  'autofit'                      : false,
  'columns'                      : [
    {
      'name' : 'taskNumber',
      'width': 70,
      'label': 'Task Number',
    },
    {
      'name' : 'text',
      'tree' : true,
      'width': 350,
      'label': 'Task Name',
    },
    {
      'name' : 'resource',
      'width': 350,
      'label': 'Resource',
    },
    {
      'name' : 'duration',
      'align': 'center',
      'width': 70,
      'label': 'Duration',
    },
  ],
  'step'                         : 1,
  'scale_unit'                   : 'day',
  'scale_offset_minimal'         : true,
  'subscales'                    : [],
  'inherit_scale_class'          : false,
  'time_step'                    : 60,
  'duration_step'                : 1,
  'date_scale'                   : '%d %M',
  'task_date'                    : '%d+%F+%Y',
  'time_picker'                  : '%H:%i',
  'task_attribute'               : 'task_id',
  'link_attribute'               : 'link_id',
  'layer_attribute'              : 'data-layer',
  'sort'                         : false,
  'initial_scroll'               : true,
  'task_scroll_offset'           : 100,
  'order_branch'                 : false,
  'order_branch_free'            : false,
  'task_height'                  : 'full',
  'min_column_width'             : 70,
  'min_grid_column_width'        : 70,
  'grid_resizer_column_attribute': 'column_index',
  'grid_resizer_attribute'       : 'grid_resizer',
  'keep_grid_width'              : false,
  'grid_resize'                  : false,
  'show_unscheduled'             : true,
  'readonly_property'            : 'readonly',
  'editable_property'            : 'editable',
  'calendar_property'            : 'calendar_id',
  'resource_calendars'           : {},
  'type_renderers'               : {},
  'open_tree_initially'          : false,
  'optimize_render'              : true,
  'prevent_default_scroll'       : false,
  'show_errors'                  : true,
  'wai_aria_attributes'          : true,
  'smart_scales'                 : true,
  'rtl'                          : false,
  'resource_property'            : 'owner_id',
  'resource_store'               : 'resource',
  'touch_drag'                   : 500,
  'touch'                        : false,
  'touch_feedback'               : true,
  'touch_feedback_duration'      : 1,
  'date_format'                  : '%Y-%m-%d+%H:%i',
  'scroll_size'                  : 15,
  'grid_width'                   : 360,
  'row_height'                   : 35,
  'scale_height'                 : 35,
  'link_line_width'              : 2,
  'link_arrow_size'              : 6,
  'lightbox_additional_height'   : 75,
};

export const getScheduleConfig = () => ({
  ...ganttExportConfig,
  'work_time'                    : true,
  'correct_work_time'            : true,
  'start_on_monday'              : true,
  columns: [
    ...ganttExportConfig.columns,
    {
      'name'  : 'start_date',
      'align' : 'center',
      'width' : 90,
      'label' : 'Start Date',
    },
    {
      'name'  : 'end_date',
      'align' : 'center',
      'width' : 90,
      'label' : 'End Date',
    },
  ],
});
